export default "__VITE_ASSET__q3equO5M__"